const { addFilter } = wp.hooks;
const { Fragment } = wp.element;
const { InspectorControls } = wp.blockEditor;
const { PanelBody, TextControl } = wp.components;
const { createHigherOrderComponent } = wp.compose;

const allowedBlocks = [
  'pg/demo-form',
  'pg/storylane-embed',
  'pg/faq-section',
  'pg/faq-section',
  'pg/faq-inner-section',
  'pg/people',
  'pg/chessboard-section',
  'pg/floating-form',
];

// Add the Block ID attribute
const addBlockIdAttribute = (settings) => {
  if (allowedBlocks.includes(settings.name)) {
    if (typeof settings.attributes !== 'undefined') {
      settings.attributes = Object.assign(settings.attributes, {
        blockId: {
          type: 'string',
          default: '',
        },
      });
    }
  }
  return settings;
};

addFilter(
  'blocks.registerBlockType',
  'block-id-field/attribute',
  addBlockIdAttribute
);

// Add the Block ID field to the Inspector Controls
const withBlockIdInspectorControls = createHigherOrderComponent((BlockEdit) => {
  return (props) => {
    if (!allowedBlocks.includes(props.name)) {
      return <BlockEdit {...props} />;
    }

    const { attributes, setAttributes } = props;
    const { blockId } = attributes;

    return (
      <Fragment>
        <BlockEdit {...props} />
        <InspectorControls>
          <PanelBody title="Block ID">
            <TextControl
              label="Block ID"
              value={blockId}
              onChange={(value) => setAttributes({ blockId: value })}
              placeholder="Enter a unique ID for this block"
            />
          </PanelBody>
        </InspectorControls>
      </Fragment>
    );
  };
}, 'withBlockIdInspectorControls');

addFilter(
  'editor.BlockEdit',
  'block-id-field/inspector-control',
  withBlockIdInspectorControls
);

// Apply the Block ID to the save element
const applyBlockIdToSave = (element, blockType, attributes) => {
  if (!allowedBlocks.includes(blockType.name)) {
    return element;
  }

  const { blockId } = attributes;

  if (blockId && element && element.props) {
    return {
      ...element,
      props: {
        ...element.props,
        id: blockId,
      },
    };
  }

  return element;
};

addFilter('blocks.getSaveElement', 'block-id-field/save', applyBlockIdToSave);
